import * as React from "react";
import { useForm } from "react-hook-form";
import { Dimensions, FlatList, StyleSheet, Text, View } from "react-native";
import { Color, globalFontStyle } from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import {Button} from "../../../components/core/Button";
import { useDispatch } from "react-redux";
import { globalImport } from "../../../common/globalImports";
import { useNavigation } from "@react-navigation/native";
import { isMobile } from "../../../utils/commonMethods";
import FormTextLabel from "../../../commonComponents/FormTextLabel";
import {globalConfigurableData, GlobalScreens} from "../../../utils/globalConstant";

const AddMoneyDetails = ({ rechargeDetails, confirmDepositClick }) => {
  const navigation = useNavigation();

  const confirmButtonClick = () => {
    if (isMobile()) {
      navigation.pop();
    }
    confirmDepositClick(rechargeDetails);
  };

  const obj = [
    {
      title: "Total credits to be added",
      val: rechargeDetails?.convertedAmount,
    },
    { title: "Amount", val: rechargeDetails?.withDrawAmount + "USDT*" },
    { title: "Gateway Fee", val: rechargeDetails?.gatewayFees },
    { title: "Network type", val: isMobile() ? rechargeDetails?.networkType : rechargeDetails?.networkType?.value },
    { title: "Network Fee", val: "To be charged by crypto payment provider" },
  ];

  return (
    <>
      <View
        style={{
          //paddingHorizontal: 10,
          paddingVertical: 10,
          //width: width,
          flex: 1,
          justifyContent: "flex-start",
        }}
      >
        <View style={styles.tableContainer}>
          {obj.map((item, index) => {
            return (
              <View
                key={index}
                style={[
                  styles.tableRow,
                  index === obj.length - 1
                    ? { borderBottomWidth: 0, marginBottom: 0 }
                    : null,
                ]}
              >
                <FormTextLabel
                labelStyles={styles.textFontStyle}
                label={item.title}
                />
                <FormTextLabel
                    labelStyles={styles.textFontStyle}
                    label={item.val}
                />
              </View>
            );
          })}
        </View>
        <FormTextLabel
            labelStyles={[
              globalFontStyle.appFontSmallText,
              { color: "#5B6779", textAlign: "center" },
            ]}
            label={'*Actual rates may vary during the time of transaction.'}
        />

        <Button
          variant="primary"
          onPress={confirmButtonClick}
          translate={true}
          style={{ flex: globalImport.isWeb ? {} : 0, marginTop: 15 }}
        >
          Confirm
        </Button>
      </View>
    </>
  );
};

export default AddMoneyDetails;

const styles = StyleSheet.create({
  textFontStyle: {
    ...globalFontStyle.appFontSubText,
    color: globalConfigurableData.primaryTextColor1,
  },
  tableRow: {
    //flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 13,
    borderBottomWidth: 0.1,
    paddingHorizontal: 18,
    paddingBottom: 10,
    borderColor: GlobalScreens.AddMoney.borderColor,
  },
  tableContainer: {
    borderWidth: 0.5,
    borderColor: GlobalScreens.AddMoney.borderColor,
    borderRadius: 6,
    //paddingHorizontal: 18,
    paddingTop: 15,
    marginBottom: 40,
    backgroundColor: globalConfigurableData.cardBgColor
  },
});
